import { Box } from '@mui/material';
import { useField } from 'formik';

import { DisplayCurrency } from 'src/components';
import { DisplayCurrencyStyleVariants } from 'src/components/DisplayCurrency';
import { useAuthContext } from 'src/contexts/AuthProvider';

function TransactionChargeValueNonEditable({ fieldName }) {
    const [{ value }] = useField(fieldName);
    const { usersCurrency } = useAuthContext();

    if (!Number.isFinite(value)) {
        return <Box sx={{ width: '100%', height: '100%' }} />;
    }

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <DisplayCurrency
                currencyAmount={value}
                disableStyling={false}
                localeLanguage={navigator.language}
                centsAmount={undefined}
                usersCurrency={usersCurrency}
                styleVariant={DisplayCurrencyStyleVariants.INPUT}
            />
        </Box>
    );
}

export default TransactionChargeValueNonEditable;
